import React from 'react';
import styled from 'styled-components';
import { motion } from 'framer-motion';
import theme from '../../theme';

const InstagramSvg = ({ fill = 'white' }) => (
  <svg
    width="2em"
    height="2em"
    viewBox="0 0 30 30"
    preserveAspectRatio="xMidYMid meet"
  >
    <path
      fill={fill}
      d="M29.91,8.81666667 C29.8853105,7.57212335 29.6497489,6.34077834 29.2133333,5.175 C28.8362071,4.17403658 28.2452441,3.26740039 27.4816667,2.51833333 C26.7325996,1.75475589 25.8259634,1.1637929 24.825,0.786666667 C23.6597478,0.350436026 22.4289819,0.114877363 21.185,0.09 C19.5833333,0.0166666667 19.0733333,0 15,0 C10.9266667,0 10.4166667,0.0166666667 8.81666667,0.09 C7.57212335,0.114689488 6.34077834,0.350251142 5.175,0.786666667 C4.17344035,1.1635783 3.26621636,1.75455368 2.51666667,2.51833333 C1.75308922,3.26740039 1.16212624,4.17403658 0.785,5.175 C0.348769359,6.34025223 0.113210696,7.57101807 0.0883333333,8.815 C0.0166666667,10.4166667 0,10.9266667 0,15 C0,19.0733333 0.0166666667,19.5833333 0.09,21.1833333 C0.114689488,22.4278767 0.350251142,23.6592217 0.786666667,24.825 C1.1637929,25.8259634 1.75475589,26.7325996 2.51833333,27.4816667 C3.26736626,28.2452858 4.17401223,28.8362551 5.175,29.2133333 C6.34025223,29.649564 7.57101807,29.8851226 8.815,29.91 C10.4166667,29.9833333 10.9266667,30 15,30 C19.0733333,30 19.5833333,29.9833333 21.1833333,29.91 C22.4278767,29.8853105 23.6592217,29.6497489 24.825,29.2133333 C26.8406744,28.4340909 28.4340909,26.8406744 29.2133333,24.825 C29.649564,23.6597478 29.8851226,22.4289819 29.91,21.185 C29.9833333,19.5833333 30,19.0733333 30,15 C30,10.9266667 29.9833333,10.4166667 29.91,8.81666667 Z M27.21,21.0616667 C27.1985005,22.0121922 27.0237348,22.9536718 26.6933333,23.845 C26.1891778,25.1537909 25.1551623,26.1884119 23.8466667,26.6933333 C22.9548037,27.0238905 22.0127497,27.1986581 21.0616667,27.21 C19.4783333,27.2816667 19.005,27.2966667 15,27.2966667 C10.995,27.2966667 10.52,27.2816667 8.93833333,27.21 C7.98781106,27.1984675 7.04633698,27.0237028 6.155,26.6933333 C5.50280627,26.4532722 4.91276662,26.0699742 4.42833333,25.5716667 C3.93023365,25.0877135 3.54694879,24.4982635 3.30666667,23.8466667 C2.9760775,22.9548125 2.80130882,22.012753 2.79,21.0616667 C2.71833333,19.4783333 2.70333333,19.005 2.70333333,15 C2.70333333,10.995 2.71833333,10.52 2.79,8.93833333 C2.80153255,7.98781106 2.9762972,7.04633698 3.30666667,6.155 C3.54672782,5.50280627 3.93002578,4.91276662 4.42833333,4.42833333 C4.9122865,3.93023365 5.50173648,3.54694879 6.15333333,3.30666667 C7.04519633,2.97610952 7.98725027,2.80134188 8.93833333,2.79 C10.5216667,2.71833333 10.995,2.70333333 15,2.70333333 C19.005,2.70333333 19.48,2.71833333 21.0616667,2.79 C22.0121889,2.80153255 22.953663,2.9762972 23.845,3.30666667 C24.4971937,3.54672782 25.0872334,3.93002578 25.5716667,4.42833333 C26.0697663,4.9122865 26.4530512,5.50173648 26.6933333,6.15333333 C27.0238905,7.04519633 27.1986581,7.98725027 27.21,8.93833333 C27.2816667,10.5216667 27.2966667,10.995 27.2966667,15 C27.2966667,19.005 27.2816667,19.48 27.21,21.0616667 Z M15,7.29666667 C10.7455665,7.29666667 7.29666667,10.7455665 7.29666667,15 C7.29666667,19.2544335 10.7455665,22.7033333 15,22.7033333 C19.2544335,22.7033333 22.7033333,19.2544335 22.7033333,15 C22.7033333,12.956949 21.8917345,10.997576 20.4470792,9.55292076 C19.002424,8.10826553 17.043051,7.29666667 15,7.29666667 Z M15,20 C12.2385763,20 10,17.7614237 10,15 C10,12.2385763 12.2385763,10 15,10 C17.7614237,10 20,12.2385763 20,15 C20,17.7614237 17.7614237,20 15,20 Z M24.8066667,6.99333333 C24.8066667,7.98744588 24.0007792,8.79333333 23.0066667,8.79333333 C22.0125541,8.79333333 21.2066667,7.98744588 21.2066667,6.99333333 C21.2066667,5.99922078 22.0125541,5.19333333 23.0066667,5.19333333 C24.0007792,5.19333333 24.8066667,5.99922078 24.8066667,6.99333333 Z"
    />
  </svg>
);

const FacebookSvg = ({ fill = 'white' }) => (
  <svg
    width="2em"
    height="2em"
    viewBox="-8 0 30 30"
    preserveAspectRatio="xMidYMid meet"
  >
    <path
      fill={fill}
      d="M3.026,5.81033333 L3.026,9.94066667 L0,9.94066667 L0,14.9913333 L3.026,14.9913333 L3.026,30 L9.242,30 L9.242,14.9916667 L13.4133333,14.9916667 C13.4133333,14.9916667 13.804,12.57 13.9933333,9.922 L9.26566667,9.922 L9.26566667,6.46866667 C9.26566667,5.95266667 9.94333333,5.25833333 10.6133333,5.25833333 L14,5.25833333 L14,0.000333333333 L9.39533333,0.000333333333 C2.87233333,2.96041403e-16 3.026,5.05566667 3.026,5.81033333"
    />
  </svg>
);

const TripadvisorSvg = ({ fill = 'white' }) => (
  <svg width="3.6em" height="3.6em" viewBox="1 1 96 96">
    <path
      fill={fill}
      d="m67.211 46.07c-3.291 0-5.971 2.648-5.982 5.917-0.012 3.252 2.681 5.959 5.939 5.967 3.266 0.01 5.949-2.674 5.947-5.943-2e-3 -3.279-2.65-5.941-5.904-5.941zm0 8.95c-1.686 0-3.043-1.332-3.039-2.983 2e-3 -1.716 1.318-3.039 3.02-3.041 1.666-2e-3 3.031 1.362 3.017 3.021-0.02 1.655-1.361 3.003-2.998 3.003z"
    />
    <path
      fill={fill}
      d="m30.512 37.514c-7.9-0.07-14.787 6.523-14.65 14.921 0.129 7.832 6.584 14.472 14.814 14.4 8.047-0.068 14.516-6.641 14.531-14.6 0.012-8.172-6.535-14.721-14.695-14.721zm0.236 23.586c-5.293 0.242-9.564-3.977-9.555-9.1 0.01-5.191 4.287-9.162 9.125-9.074 5.023-6e-3 9.1 4.049 9.086 9.07-0.013 5.082-4.019 8.893-8.656 9.104z"
    />
    <path
      fill={theme.colors.primary.toHex()}
      d="m48.875 0c-26.992 0-48.875 21.883-48.875 48.875s21.883 48.875 48.875 48.875 48.875-21.883 48.875-48.875-21.883-48.875-48.875-48.875zm28.096 67.852c-2.984 1.896-6.283 2.795-9.807 2.814-1.48 0.01-2.955-0.189-4.4-0.564-3.522-0.914-6.545-2.672-9.035-5.33-0.33-0.35-0.639-0.713-0.987-1.108-1.316 1.961-2.611 3.892-3.939 5.871-1.32-1.974-2.6-3.886-3.873-5.787-0.088 0.045-0.113 0.051-0.131 0.065-0.029 0.025-0.055 0.056-0.076 0.082-3.012 3.556-6.801 5.734-11.414 6.465-2.568 0.406-5.109 0.261-7.604-0.428-3.533-0.971-6.537-2.834-8.963-5.586-2.371-2.688-3.846-5.812-4.398-9.363-0.633-3.312 0.137-6.508 0.33-7.282 0.559-2.252 1.531-4.322 2.867-6.225 0.094-0.135 0.127-0.375 0.082-0.535-0.545-1.998-1.482-3.816-2.582-5.557-0.279-0.441-0.613-0.85-0.922-1.275v-0.148c0.061 8e-3 0.123 0.02 0.184 0.02 3.697 2e-3 7.396 2e-3 11.094-4e-3 0.162 0 0.34-0.066 0.479-0.154 2.598-1.668 5.367-2.988 8.275-4.016 2.098-0.74 4.238-1.318 6.424-1.742 2.115-0.408 4.24-0.697 6.389-0.838 5.238-0.404 9.426 0.15 12.211 0.539 2.053 0.289 4.064 0.807 6.051 1.416 3.469 1.068 6.74 2.553 9.818 4.477 0.213 0.133 0.5 0.217 0.752 0.217 3.613 0.016 7.227 0.01 10.84 0.014 0.291 0 0.582 0.031 0.871 0.047 0 0.07 0.01 0.1-2e-3 0.117-0.168 0.258-0.34 0.516-0.508 0.775-1.225 1.879-2.273 3.848-2.893 6.021-0.066 0.232-0.082 0.428 0.076 0.658 3.219 4.621 4.243 9.693 2.899 15.162-1.181 4.795-3.929 8.533-8.108 11.182z"
    />
    <path
      fill={fill}
      d="m30.236 46.07c-3.209 6e-3 -5.898 2.715-5.891 5.936 8e-3 3.26 2.695 5.941 5.963 5.949 3.248 8e-3 5.939-2.697 5.932-5.965-0.01-3.299-2.676-5.926-6.004-5.92zm0.075 8.981c-1.723 2e-3 -3.051-1.328-3.051-3.061 0-1.701 1.326-3.021 3.043-3.023 1.689-2e-3 3.049 1.348 3.057 3.035 5e-3 1.672-1.366 3.043-3.049 3.049z"
    />
    <path
      fill={fill}
      d="m66.902 37.57c-8.019 0.164-14.295 6.627-14.367 14.622 0 8.121 6.59 14.756 14.682 14.725 8.123-0.029 14.682-6.477 14.676-14.688-4e-3 -8.463-6.87-14.825-14.991-14.659zm0.66 23.532c-5.271 0.203-9.489-4-9.487-9.094 2e-3 -5.154 4.252-9.17 9.112-9.082 5.027-0.01 9.099 4.039 9.099 9.061-1e-3 5.04-4.003 8.935-8.724 9.115z"
    />
    <path
      fill={fill}
      d="m54.732 38.639c3.248-2.98 7.117-4.543 11.506-4.875-5.209-2.314-10.701-3.299-16.355-3.408-6.424-0.125-12.674 0.822-18.643 3.326 4.463 0.271 8.383 1.828 11.695 4.838 3.305 3.008 5.242 6.756 5.945 11.166 0.724-4.358 2.608-8.073 5.852-11.047z"
    />
  </svg>
);

const Circle = styled(motion.a)`
  width: 3em;
  height: 3em;
  border-radius: 50%;
  background: ${props => props.theme.colors.primary.toHex()};
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
`;

const CircleButton = styled(motion.button)`
  width: 3em;
  height: 3em;
  border-radius: 50%;
  background: ${props => props.theme.colors.primary.toHex()};
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  outline: none;
  border: none;
`;

export const buttonVariants = {
  closed: {
    rotate: 0,
    transition: {
      rotate: { stiffness: 1000, velocity: -100 },
    },
  },
  open: {
    rotate: -90,
    transition: {
      rotate: { stiffness: 1000 },
      delay: 0.1,
    },
  },
};

const SocialLink = Component => ({ to, children, ...rest }) => (
  <Circle
    href={to}
    target={'_blank'}
    {...rest}
    variants={buttonVariants}
    whileHover={{ scale: 1.1 }}
    whileTap={{ scale: 0.95 }}
  >
    <Component />
  </Circle>
);

const SociaButtonPlain = Component => ({ to, ...rest }) => (
  <CircleButton {...rest}>
    <Component />
  </CircleButton>
);

export const InstagramLink = SocialLink(InstagramSvg);
export const FacebookLink = SocialLink(FacebookSvg);
export const TripAdvisorLink = SocialLink(TripadvisorSvg);

export const InstagramButtonPlain = SociaButtonPlain(InstagramSvg);
export const FacebookButtonPlain = SociaButtonPlain(FacebookSvg);
